import React from 'react';
import './Hero.css';
import heroImg from '../assets/hero.png';

const Hero = () => (
  <section className="hero">
    <div className="hero-content">
      <div>
        <h1>Frios & Cia Atacado e Distribuidora</h1>
        <p>
          Especialistas em frios, congelados, bebidas, polpas de frutas, salgados e muito mais.<br/>
          Qualidade, variedade e ótimo custo-benefício para o seu negócio!
        </p>
        <a href="https://wa.me/5514996146027" target="_blank" rel="noopener noreferrer">
          <button className="hero-cta">Fale com a gente no WhatsApp</button>
        </a>
      </div>
      <img src={heroImg} alt="Produtos Frios & Cia" className="hero-img" />
    </div>
  </section>
);

export default Hero;
